export default __webpack_public_path__ + "assets/images/421ab9effc274a679171da4dd9400dfa.svg";